import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const DetailPanelRoot = styled('div')(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.primary.contrastText,
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const DetailItemRow = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: 0,
  width: '100%',
  height: 32,
  backgroundColor: theme.palette.grey[50],
  flex: 'none',
  alignSelf: 'stretch',
}));

export const DetailItemExpandCell = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0, 0.5),
  width: 24,
  minWidth: 24,
  height: 32,
  backgroundColor: theme.palette.grey[50],
  flex: 'none',
}));

export const DetailItemExpandButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
  marginLeft: 8,
  color: theme.palette.action.active,
}));

export const DetailItemLabelContainer = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  gap: theme.spacing(3),
  width: 196,
  minWidth: 196,
  height: 32,
  backgroundColor: theme.palette.grey[50],
  flex: 'none',
}));

export const DetailItemLabel = styled(Typography)(({ theme }) => ({
  ...theme.typography['body-small'],
  color: theme.palette.text.primary,
  whiteSpace: 'nowrap',
})) as typeof Typography;

export const DetailItemSpacer = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  height: 32,
  backgroundColor: theme.palette.grey[50],
  flex: '1 1 auto',
  alignSelf: 'stretch',
  minWidth: 0,
}));

export const DetailItemContent = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  width: '100%',
  padding: theme.spacing(2.5, 2),
}));

export const DetailItemCollapse = styled(Collapse)({});
